import { takeLatest, put, call } from 'redux-saga/effects';

import { findLocalEstoqueCadastro } from '../service';
import {
  FIND_LOCAL_ESTOQUE_CADASTRO,
  FIND_LOCAL_ESTOQUE_CADASTRO_PENDING,
  FIND_LOCAL_ESTOQUE_CADASTRO_SUCCESS,
  FIND_LOCAL_ESTOQUE_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaFindLocalEstoqueCadastro(action) {
  yield put({ type: FIND_LOCAL_ESTOQUE_CADASTRO_PENDING, id: action.id })

  try {

    const registro = yield call(findLocalEstoqueCadastro, action.id);

    yield put({ type: FIND_LOCAL_ESTOQUE_CADASTRO_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_LOCAL_ESTOQUE_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindLocalEstoqueCadastro() {
  yield takeLatest(FIND_LOCAL_ESTOQUE_CADASTRO, sagaFindLocalEstoqueCadastro)
}
